import http from './http.js'
import Vue from 'vue'
import router from '@/router'
import store from './store.js'
//
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
//强制登录
const must ={
  mustlogin(login){
    const  token_type =store.state.token_type
    const  access_token = store.state.token
    if(login && (token_type==null || access_token==null)){
        router.push({path:'/login'})
        return true
    }
    return false
  }
}

export default{
  install(Vue){
   Vue.prototype.gets = function (url,params,login=true){
     //console.log(resquest)
     var mlogin=must.mustlogin(login)
      if(mlogin)return false
      return http.get(url,params)
   }
  Vue.prototype.post = function (url,params,login=true){
        var mlogin=must.mustlogin(login)
      if(mlogin)return false
      return http.post(url,params)
  }
  Vue.prototype.put = function (url,params,login=true){
      var mlogin=must.mustlogin(login)
       if(mlogin)return false
      return http.put(url,params)
  }
  Vue.prototype.delete = function (url,params,login=true){
      var mlogin=must.mustlogin(login)
      if(mlogin)return false
      return http.delete(url,params)
  }

}
}



// WEBPACK FOOTER //
// ./src/utils/api.js